import { range } from 'lodash'
import IsItem from './IsItem'

export default class ItemFactory {
  private settings: any

  public constructor(settings: any) {
    this.settings = settings
  }

  public scanRange(from: number, til: number, key: (i: number) => string = i => `item${i}`) {
    return range(from, til + 1).map(i => this.from(this.settings[key(i)]))
  }

  public scan(pattern = /.*/) {
    const out: { [k: string]: IsItem } = {}
    Object.keys(this.settings).forEach(key => {
      if (this.settings[key].type === 'likert' && key.match(pattern)) {
        out[key] = this.from(this.settings[key])
      }
    })
    return out
  }

  public item(key: string) {
    return this.from(this.settings[key])
  }

  public from(itemSettings: IsItem): IsItem {
    return itemSettings
  }
}
